import {
  PERITADOR_ACT_GET_FILTER_REQUEST_BEGIN,
  PERITADOR_ACT_GET_FILTER_REQUEST_SUCCESS,
  PERITADOR_ACT_GET_FILTER_REQUEST_FAILURE,
  PERITADOR_ACT_GET_FILTER_REQUEST_DISMISS_ERROR,
} from './constants'
import { REACT_APP_PERITADOR_API } from '../../../common/config'
import axios from 'axios'

export function actGetFilterRequest(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PERITADOR_ACT_GET_FILTER_REQUEST_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${REACT_APP_PERITADOR_API}/requests/findNamePatentEmailForStatus/${args}`,
      )
      
      doRequest.then(
        (res) => {
          dispatch({
            type: PERITADOR_ACT_GET_FILTER_REQUEST_SUCCESS,
            data: res.data,
          })
          resolve(res)
        },
        (err) => {
          dispatch({
            type: PERITADOR_ACT_GET_FILTER_REQUEST_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

export function dismissActGetFilterRequestError() {
  return {
    type: PERITADOR_ACT_GET_FILTER_REQUEST_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_GET_FILTER_REQUEST_BEGIN:
      return {
        ...state,
        actGetFilterRequestPending: true,
        actGetFilterRequestError: null,
      }

    case PERITADOR_ACT_GET_FILTER_REQUEST_SUCCESS:
      return {
        ...state,
        actGetFilterRequestPending: false,
        actGetFilterRequestError: null,
        requests: action.data,
      }

    case PERITADOR_ACT_GET_FILTER_REQUEST_FAILURE:
      return {
        ...state,
        actGetFilterRequestPending: false,
        actGetFilterRequestError: action.data.error,
      }

    case PERITADOR_ACT_GET_FILTER_REQUEST_DISMISS_ERROR:
      return {
        ...state,
        actGetFilterRequestError: null,
      }

    default:
      return state
  }
}
